module.exports = __webpack_public_path__ + "img/332.61513b86.jpg";